import { createSvgIcon } from '@mui/material';

export const InfoBlack = createSvgIcon(
  <svg fontSize={ 25 } viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.99935 0.666748C4.39935 0.666748 0.666016 4.40008 0.666016 9.00008C0.666016 13.6001 4.39935 17.3334 8.99935 17.3334C13.5993 17.3334 17.3327 13.6001 17.3327 9.00008C17.3327 4.40008 13.5993 0.666748 8.99935 0.666748ZM9.83268 13.1667H8.16602V8.16675H9.83268V13.1667ZM9.83268 6.50008H8.16602V4.83342H9.83268V6.50008Z" fill="#6B7280" />
  </svg>,
  'InfoBlack',
);
